/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_Step_ThreeInputs */

const en_directory_guide_how_it_works_step_three = /** @type {(inputs: Directory_Guide_How_It_Works_Step_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Published listings can be managed from your account and discovered through the directory.`)
};

const zh_directory_guide_how_it_works_step_three = /** @type {(inputs: Directory_Guide_How_It_Works_Step_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布后的产品可在账户中管理，并能通过目录被发现。`)
};

/**
* | output |
* | --- |
* | "Published listings can be managed from your account and discovered through the directory." |
*
* @param {Directory_Guide_How_It_Works_Step_ThreeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_step_three = /** @type {((inputs?: Directory_Guide_How_It_Works_Step_ThreeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_Step_ThreeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_step_three(inputs)
	return zh_directory_guide_how_it_works_step_three(inputs)
});
export { directory_guide_how_it_works_step_three as "directory.guide.how_it_works.step_three" }